<Button
  on:click
  on:focus={() => {focused=true;}}
  on:blur={() => {focused=false;}}
  align="center"
  rounded="sm"
  vertical="top"
  bg="transparent"
  pointer
  hover="big-add-button-hover"
  border={focused ? "3" : "plus"}
  shadow={focused ? "lg" : null}
  w="22ch"
  py="0.75" 
  px="xs" 
  mt={focused ? "-2px" : null}
  mr="xs"
  mb="sm"
  >

  <Icon name="add" size="3.25" h="2.5" color="green-"/>
  <Panel mt="xs" align="center" px="lg">
    <Text line="normal" nm bold color="green-">{label}</Text>
  </Panel>

</Button>

<script>
  import { Box, Icon, Panel, Label, Text, Button } from 'svelte-stylo';

  export let 
    label = '';

  let 
    focused = false;

</script>

<style>
  :global(.big-add-button-hover:hover) {
    margin-top: -2px;
    nomargin-left: -2px;
    box-shadow: 2px 2px 8px #aaa;
    border: 2px transparent solid !important;
  }  
</style>